export default __webpack_public_path__ + "static/media/Instagram.63544000.png";